import { render } from "./footerBar.vue?vue&type=template&id=30deb195"
import script from "./footerBar.vue?vue&type=script&lang=js"
export * from "./footerBar.vue?vue&type=script&lang=js"

import "./footerBar.vue?vue&type=style&index=0&id=30deb195&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__